/**
 * SP表示時のハンバーガーメニュー（.l-nav を左からスライド表示）
 */
export default class Header {
	constructor() {
		this.trigger = document.querySelector('.js-humburger-trigger');
		this.nav = document.querySelector('.l-nav');
		this.mediaQuery = window.matchMedia('(max-width: 767.98px)');
		this.isOpen = false;
		this.scrollLockY = 0;

		this.onTriggerClick = this.onTriggerClick.bind(this);
		this.onMediaChange = this.onMediaChange.bind(this);
	}

	init() {
		if (!this.trigger || !this.nav) {
			return;
		}

		this.trigger.setAttribute('aria-expanded', 'false');

		this.trigger.addEventListener('click', this.onTriggerClick);

		if (typeof this.mediaQuery.addEventListener === 'function') {
			this.mediaQuery.addEventListener('change', this.onMediaChange);
		} else {
			this.mediaQuery.addListener(this.onMediaChange);
		}
	}

	onMediaChange() {
		if (!this.mediaQuery.matches && this.isOpen) {
			this.close();
		}
	}

	onTriggerClick(event) {
		if (!this.mediaQuery.matches) {
			return;
		}
		event.preventDefault();
		this.toggle();
	}

	toggle() {
		if (this.isOpen) {
			this.close();
		} else {
			this.open();
		}
	}

	open() {
		if (this.isOpen) {
			return;
		}
		this.isOpen = true;
		this.scrollLockY = window.scrollY;

		document.body.style.top = `-${this.scrollLockY}px`;
		document.documentElement.classList.add('is-nav-open');
		document.body.classList.add('is-nav-open');

		this.nav.classList.add('is-open');
		this.trigger.classList.add('is-open');
		this.trigger.setAttribute('aria-expanded', 'true');
	}

	close() {
		if (!this.isOpen) {
			return;
		}
		this.isOpen = false;

		document.body.style.top = '';
		document.documentElement.classList.remove('is-nav-open');
		document.body.classList.remove('is-nav-open');

		this.nav.classList.remove('is-open');
		this.trigger.classList.remove('is-open');
		this.trigger.setAttribute('aria-expanded', 'false');

		const y = this.scrollLockY;
		const html = document.documentElement;
		const prevInline = html.style.scrollBehavior;
		html.style.scrollBehavior = 'auto';
		window.scrollTo(0, y);
		html.style.scrollBehavior = prevInline;
	}
}
